import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/newControl.svg'
import _imports_1 from '@/assets/controlClone.svg'
import _imports_2 from '@/assets/sortBy.svg'
import _imports_3 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "flex justify-between items-center h-8" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = {
  ref: "menuContainer",
  class: "flex flex-row-reverse"
}
const _hoisted_9 = {
  key: 1,
  class: "card shadow-sm z-50 absolute cursor-pointer top-24 w-40"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "mt-3" }
const _hoisted_13 = { class: "headerText" }
const _hoisted_14 = { class: "mt-5 bg-white border border-lightgrey relative rounded mapping-tabs-shell" }
const _hoisted_15 = { class: "pb-5 px-5 pt-5 w-full h-full flex flex-col min-h-0" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_18 = {
  key: 1,
  class: "w-full"
}
const _hoisted_19 = {
  key: 0,
  class: "noScrollbar tabStructure1 overflow-y-auto"
}
const _hoisted_20 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_21 = {
  key: 1,
  class: "h-full"
}
const _hoisted_22 = { class: "statuscontainer pt-4" }
const _hoisted_23 = { class: "formcontainer flex flex-col" }
const _hoisted_24 = { class: "row flex flex-row w-full" }
const _hoisted_25 = { class: "row flex flex-row w-full" }
const _hoisted_26 = { class: "w-6/12" }
const _hoisted_27 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_28 = { class: "w-6/12 mb-3 ml-4" }
const _hoisted_29 = {
  key: 2,
  class: "text-sm mt-2"
}
const _hoisted_30 = { class: "row flex flex-row w-full" }
const _hoisted_31 = { class: "row flex flex-row w-full" }
const _hoisted_32 = { class: "w-3/6" }
const _hoisted_33 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_34 = { class: "row flex flex-row w-full" }
const _hoisted_35 = { class: "w-3/6 leftspacing" }
const _hoisted_36 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_37 = { class: "row flex flex-row w-full" }
const _hoisted_38 = { class: "w-6/12" }
const _hoisted_39 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_40 = { class: "w-3/6 leftspacing" }
const _hoisted_41 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_42 = { class: "row flex flex-row w-full" }
const _hoisted_43 = { class: "w-6/12" }
const _hoisted_44 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_45 = { class: "w-6/12 leftspacing" }
const _hoisted_46 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_47 = { class: "row flex flex-row w-full" }
const _hoisted_48 = { class: "w-3/6" }
const _hoisted_49 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_50 = {
  key: 0,
  class: "w-3/6 pl-4"
}
const _hoisted_51 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_52 = {
  key: 1,
  class: "w-3/6 pl-4"
}
const _hoisted_53 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_54 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_55 = { class: "w-3/6" }
const _hoisted_56 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_57 = { class: "w-3/6 leftspacing" }
const _hoisted_58 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_59 = { class: "row flex flex-row w-full" }
const _hoisted_60 = { class: "" }
const _hoisted_61 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_62 = { key: 2 }
const _hoisted_63 = {
  key: 1,
  class: "noScrollbar tabStructure1 mapping-tab-pane"
}
const _hoisted_64 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_65 = {
  key: 1,
  class: "tableCornerRadius mapping-inline-table"
}
const _hoisted_66 = { class: "table-container table-container-fit" }
const _hoisted_67 = { class: "table-header-wrap" }
const _hoisted_68 = { class: "table-header-row" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 0,
  class: "pl-5 cursor-pointer"
}
const _hoisted_71 = {
  key: 1,
  class: "cursor-pointer"
}
const _hoisted_72 = ["onMousedown"]
const _hoisted_73 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_74 = ["onUpdate:modelValue"]
const _hoisted_75 = ["value"]
const _hoisted_76 = ["value"]
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = ["value"]
const _hoisted_79 = ["value"]
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = ["value"]
const _hoisted_82 = ["value"]
const _hoisted_83 = { key: 3 }
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = { class: "table-body-scroll" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "cursor-pointer rowHeight" }
const _hoisted_88 = ["colspan"]
const _hoisted_89 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { class: "cursor-pointer rowHeight" }
const _hoisted_92 = ["colspan"]
const _hoisted_93 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { key: 1 }
const _hoisted_97 = { key: 2 }
const _hoisted_98 = {
  key: 3,
  class: "relative menuWidth",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_99 = { key: 4 }
const _hoisted_100 = { class: "table-ellipsis" }
const _hoisted_101 = ["onMousemove"]
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 2 }
const _hoisted_104 = {
  key: 2,
  class: "noScrollbar tabStructure1 mapping-tab-pane"
}
const _hoisted_105 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_106 = {
  key: 1,
  class: "tableCornerRadius mapping-inline-table"
}
const _hoisted_107 = { class: "table-container table-container-fit" }
const _hoisted_108 = { class: "table-header-wrap" }
const _hoisted_109 = { class: "buttomStyle table-header-row" }
const _hoisted_110 = ["onClick"]
const _hoisted_111 = {
  key: 0,
  class: "pl-5 cursor-pointer"
}
const _hoisted_112 = {
  key: 1,
  class: "cursor-pointer"
}
const _hoisted_113 = ["onMousedown"]
const _hoisted_114 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_115 = ["onUpdate:modelValue"]
const _hoisted_116 = ["value"]
const _hoisted_117 = ["value"]
const _hoisted_118 = ["onUpdate:modelValue"]
const _hoisted_119 = ["value"]
const _hoisted_120 = ["value"]
const _hoisted_121 = ["onUpdate:modelValue"]
const _hoisted_122 = { class: "table-body-scroll" }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "cursor-pointer rowHeight" }
const _hoisted_125 = ["colspan"]
const _hoisted_126 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_127 = { key: 1 }
const _hoisted_128 = { class: "cursor-pointer rowHeight" }
const _hoisted_129 = ["colspan"]
const _hoisted_130 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_131 = ["onClick"]
const _hoisted_132 = { key: 0 }
const _hoisted_133 = { key: 1 }
const _hoisted_134 = { key: 2 }
const _hoisted_135 = { class: "table-ellipsis" }
const _hoisted_136 = ["onMousemove"]
const _hoisted_137 = { key: 0 }
const _hoisted_138 = { key: 2 }
const _hoisted_139 = {
  key: 3,
  class: "noScrollbar tabStructure1 mapping-tab-pane"
}
const _hoisted_140 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_141 = {
  key: 1,
  class: "tableCornerRadius mapping-inline-table"
}
const _hoisted_142 = { class: "table-container table-container-fit" }
const _hoisted_143 = { class: "table-header-wrap" }
const _hoisted_144 = { class: "table-header-row" }
const _hoisted_145 = ["onClick"]
const _hoisted_146 = {
  key: 0,
  class: "pl-5 cursor-pointer"
}
const _hoisted_147 = {
  key: 1,
  class: "cursor-pointer"
}
const _hoisted_148 = ["onMousedown"]
const _hoisted_149 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_150 = ["onUpdate:modelValue"]
const _hoisted_151 = ["value"]
const _hoisted_152 = ["value"]
const _hoisted_153 = ["onUpdate:modelValue"]
const _hoisted_154 = ["value"]
const _hoisted_155 = ["value"]
const _hoisted_156 = ["onUpdate:modelValue"]
const _hoisted_157 = ["value"]
const _hoisted_158 = ["value"]
const _hoisted_159 = ["onUpdate:modelValue"]
const _hoisted_160 = { class: "table-body-scroll" }
const _hoisted_161 = { key: 0 }
const _hoisted_162 = { class: "cursor-pointer rowHeight" }
const _hoisted_163 = ["colspan"]
const _hoisted_164 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_165 = { key: 1 }
const _hoisted_166 = { class: "cursor-pointer rowHeight" }
const _hoisted_167 = ["colspan"]
const _hoisted_168 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_169 = ["onClick"]
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { key: 2 }
const _hoisted_173 = {
  key: 3,
  class: "relative menuWidth",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_174 = { key: 4 }
const _hoisted_175 = { class: "table-ellipsis" }
const _hoisted_176 = ["onMousemove"]
const _hoisted_177 = { key: 0 }
const _hoisted_178 = { key: 2 }
const _hoisted_179 = {
  key: 4,
  class: "noScrollbar tabStructure1 history-tab-pane mapping-tab-pane"
}
const _hoisted_180 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_181 = {
  key: 1,
  class: "history-tab-inner flex flex-col flex-1 min-h-0 overflow-hidden pt-2"
}
const _hoisted_182 = { class: "border-b border-lightgrey flex justify-between pb-2 flex-shrink-0" }
const _hoisted_183 = { class: "buttonposition flex justify-end items-center" }
const _hoisted_184 = { class: "history-entries-scroll flex-1 min-h-0 overflow-y-auto pr-2 scrollBarColour" }
const _hoisted_185 = { class: "flex" }
const _hoisted_186 = {
  key: 0,
  class: "initials"
}
const _hoisted_187 = {
  key: 1,
  class: "initials"
}
const _hoisted_188 = { class: "logContainer w-93" }
const _hoisted_189 = { class: "flex" }
const _hoisted_190 = {
  key: 0,
  class: "font-semibold mt-1.5 text-xs"
}
const _hoisted_191 = {
  key: 1,
  class: "font-semibold mt-1.5 text-xs"
}
const _hoisted_192 = {
  key: 2,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_193 = { class: "pl-2" }
const _hoisted_194 = { class: "mt-3" }
const _hoisted_195 = {
  key: 3,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_196 = { class: "pl-2" }
const _hoisted_197 = {
  key: 4,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_198 = { class: "pl-2" }
const _hoisted_199 = {
  key: 5,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_200 = { class: "pl-2" }
const _hoisted_201 = { class: "mt-3" }
const _hoisted_202 = { key: 1 }
const _hoisted_203 = {
  key: 6,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_204 = { class: "pl-2" }
const _hoisted_205 = { class: "mt-3" }
const _hoisted_206 = { key: 1 }
const _hoisted_207 = {
  key: 7,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_208 = { class: "pl-2" }
const _hoisted_209 = { class: "mt-3" }
const _hoisted_210 = {
  key: 8,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_211 = { class: "pl-2" }
const _hoisted_212 = {
  key: 9,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_213 = { class: "pl-2" }
const _hoisted_214 = {
  key: 10,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_215 = { class: "pl-2" }
const _hoisted_216 = {
  key: 11,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_217 = { class: "pl-2" }
const _hoisted_218 = {
  key: 12,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_219 = { class: "pl-2" }
const _hoisted_220 = {
  key: 13,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_221 = { class: "pl-2" }
const _hoisted_222 = {
  key: 0,
  class: "mt-1 text-xs"
}
const _hoisted_223 = { class: "ml-0.5" }
const _hoisted_224 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_225 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_226 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_227 = { key: 0 }
const _hoisted_228 = { key: 1 }
const _hoisted_229 = { class: "flex flex-col h-full" }
const _hoisted_230 = { class: "flex-1 overflow-auto" }
const _hoisted_231 = ["disabled"]
const _hoisted_232 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_233 = { class: "formcontainer flex flex-col" }
const _hoisted_234 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_235 = { class: "w-full mt-3" }
const _hoisted_236 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_237 = {
  key: 0,
  class: "error-text"
}
const _hoisted_238 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_239 = { class: "flex" }
const _hoisted_240 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_241 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_242 = {
  key: 0,
  class: "error-text"
}
const _hoisted_243 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_244 = { key: 1 }
const _hoisted_245 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_246 = {
  key: 0,
  class: "error-text"
}
const _hoisted_247 = { class: "formcontainer flex flex-col" }
const _hoisted_248 = { class: "row flex flex-row w-full" }
const _hoisted_249 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_250 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_251 = { key: 1 }
const _hoisted_252 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_253 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_254 = { class: "formcontainer flex flex-col" }
const _hoisted_255 = { class: "row flex flex-row w-full" }
const _hoisted_256 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_257 = { key: 1 }
const _hoisted_258 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_259 = { key: 1 }
const _hoisted_260 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_261 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_262 = { key: 0 }
const _hoisted_263 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_264 = { class: "w-6/12" }
const _hoisted_265 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_266 = {
  key: 0,
  class: "error-text"
}
const _hoisted_267 = ["disabled"]
const _hoisted_268 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_269 = { class: "formcontainer flex flex-col" }
const _hoisted_270 = { class: "w-full" }
const _hoisted_271 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_272 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_273 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_274 = { class: "w-full" }
const _hoisted_275 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_276 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_277 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_278 = { class: "w-full" }
const _hoisted_279 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_280 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_281 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_282 = { class: "w-full" }
const _hoisted_283 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_284 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_285 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_286 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_287 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_288 = { key: 1 }
const _hoisted_289 = { key: 0 }
const _hoisted_290 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_291 = ["disabled"]
const _hoisted_292 = ["disabled"]
const _hoisted_293 = { key: 1 }
const _hoisted_294 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_295 = ["disabled"]
const _hoisted_296 = { key: 2 }
const _hoisted_297 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_298 = ["disabled"]
const _hoisted_299 = { key: 3 }
const _hoisted_300 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_301 = ["disabled"]
const _hoisted_302 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_303 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_304 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_305 = { key: 0 }
const _hoisted_306 = { key: 1 }
const _hoisted_307 = { class: "flex flex-col h-full" }
const _hoisted_308 = { class: "flex-1 overflow-auto" }
const _hoisted_309 = ["disabled"]
const _hoisted_310 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_311 = { class: "formcontainer flex flex-col" }
const _hoisted_312 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_313 = { class: "w-full mt-3" }
const _hoisted_314 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_315 = {
  key: 0,
  class: "error-text"
}
const _hoisted_316 = {
  key: 1,
  class: "row flex flex-row w-full"
}
const _hoisted_317 = { class: "w-full mt-3" }
const _hoisted_318 = ["disabled"]
const _hoisted_319 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_320 = {
  key: 0,
  class: "error-text"
}
const _hoisted_321 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_322 = { class: "flex flex-row w-full" }
const _hoisted_323 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_324 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_325 = {
  key: 0,
  class: "error-text"
}
const _hoisted_326 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_327 = { key: 1 }
const _hoisted_328 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_329 = {
  key: 0,
  class: "error-text"
}
const _hoisted_330 = { class: "flex flex-row w-full" }
const _hoisted_331 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_332 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_333 = { key: 1 }
const _hoisted_334 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_335 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_336 = { class: "formcontainer flex flex-col" }
const _hoisted_337 = { class: "row flex flex-row w-full" }
const _hoisted_338 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_339 = { key: 1 }
const _hoisted_340 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_341 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_342 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_343 = { key: 1 }
const _hoisted_344 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_345 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_346 = { class: "w-6/12" }
const _hoisted_347 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_348 = {
  key: 0,
  class: "error-text"
}
const _hoisted_349 = { class: "w-full" }
const _hoisted_350 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_351 = ["disabled"]
const _hoisted_352 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_353 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_354 = { class: "w-full" }
const _hoisted_355 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_356 = ["disabled"]
const _hoisted_357 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_358 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_359 = { class: "w-full" }
const _hoisted_360 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_361 = ["disabled"]
const _hoisted_362 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_363 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_364 = { class: "w-full" }
const _hoisted_365 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_366 = ["disabled"]
const _hoisted_367 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_368 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_369 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_370 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_371 = { key: 1 }
const _hoisted_372 = { key: 0 }
const _hoisted_373 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_374 = ["disabled"]
const _hoisted_375 = ["disabled"]
const _hoisted_376 = { key: 1 }
const _hoisted_377 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_378 = ["disabled"]
const _hoisted_379 = { key: 2 }
const _hoisted_380 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_381 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_382 = { class: "pl-2" }
const _hoisted_383 = { class: "flex flex-col h-full" }
const _hoisted_384 = { class: "flex-1 overflow-auto" }
const _hoisted_385 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_386 = { class: "formcontainer flex flex-col" }
const _hoisted_387 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_388 = { class: "w-full mt-3" }
const _hoisted_389 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_390 = {
  key: 0,
  class: "error-text"
}
const _hoisted_391 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_392 = { class: "formcontainer flex flex-col" }
const _hoisted_393 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_394 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_395 = {
  key: 0,
  class: "error-text"
}
const _hoisted_396 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_397 = {
  key: 0,
  class: "error-text"
}
const _hoisted_398 = { class: "formcontainer flex flex-col" }
const _hoisted_399 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_400 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_401 = { class: "mt-2" }
const _hoisted_402 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_403 = { key: 1 }
const _hoisted_404 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_405 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_406 = { class: "formcontainer flex flex-col" }
const _hoisted_407 = { class: "row flex flex-row w-full" }
const _hoisted_408 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_409 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_410 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_411 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_412 = { class: "w-6/12" }
const _hoisted_413 = { class: "w-full" }
const _hoisted_414 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_415 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_416 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_417 = { class: "w-full" }
const _hoisted_418 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_419 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_420 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_421 = { class: "w-full" }
const _hoisted_422 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_423 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_424 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_425 = { class: "w-full" }
const _hoisted_426 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_427 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_428 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_429 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_430 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_431 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_432 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_433 = { class: "pl-2" }
const _hoisted_434 = { class: "flex flex-col h-full" }
const _hoisted_435 = { class: "flex-1 overflow-auto" }
const _hoisted_436 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_437 = { class: "formcontainer flex flex-col" }
const _hoisted_438 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_439 = { class: "w-full" }
const _hoisted_440 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_441 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_442 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_MessageDialog = _resolveComponent("MessageDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.modalMode ? 'details-in-modal mapping-modal' : 'pt-3 pb-10 pl-5 pr-5')
    }, [
      (!_ctx.modalMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.modalMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.systemObj.systemName != undefined || _ctx.systemObj.systemName != '')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.systemObj.systemName), 1))
                : (_openBlock(), _createElementBlock("h1", _hoisted_5, "System"))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.selectedTabIndex == 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
                  class: _normalizeClass(["btns flex justify-center items-center", _ctx.isAddDisabled ? 'btndisabled pointer-events-none':'btnprimary'])
                }, "Add", 2))
              : _createCommentVNode("", true),
            (_ctx.isMenuVisible)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  _createElementVNode("li", {
                    class: "px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.customPopupPopup && _ctx.customPopupPopup(...args)))
                  }, _cache[97] || (_cache[97] = [
                    _createElementVNode("div", { class: "flex" }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "",
                        class: "mr-2"
                      }),
                      _createTextVNode("New Control")
                    ], -1)
                  ])),
                  _createElementVNode("li", {
                    class: "px-4 py-2 cursor-pointer h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.customClonePopup && _ctx.customClonePopup(...args)))
                  }, _cache[98] || (_cache[98] = [
                    _createElementVNode("div", { class: "flex" }, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: "",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Clone Control")
                    ], -1)
                  ]))
                ]))
              : _createCommentVNode("", true)
          ], 512),
          (_ctx.selectedTabIndex == 1 || _ctx.selectedTabIndex == 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(_ctx.activeControlsListDisplay.length>0 ? 'filterButton':'btndisabled borderForBtndisabled pointer-events-none'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filtersOpen()))
              }, [
                _createElementVNode("img", {
                  src: _ctx.activeControlsListDisplay.length>0 ? require('@/assets/filter.svg') : require('@/assets/filterIcon_Disabled.svg')
                }, null, 8, _hoisted_10),
                _cache[99] || (_cache[99] = _createTextVNode(" Filters "))
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.selectedTabIndex == 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(_ctx.allControlsListDisplay.length>0 ? 'filterButton':'btndisabled borderForBtndisabled pointer-events-none'),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filtersOpen()))
              }, [
                _createElementVNode("img", {
                  src: _ctx.allControlsListDisplay.length>0 ? require('@/assets/filter.svg') : require('@/assets/filterIcon_Disabled.svg')
                }, null, 8, _hoisted_11),
                _cache[100] || (_cache[100] = _createTextVNode(" Filters "))
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.systemObj?.description), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Tabs, {
            value: _ctx.selectedTabIndex,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
            scrollable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TabList, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab, index) => {
                    return (_openBlock(), _createBlock(_component_Tab, {
                      key: index,
                      value: index,
                      onClick: ($event: any) => (_ctx.toggleTabs(tab))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tab.displayName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanels, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
                    return (_openBlock(), _createBlock(_component_TabPanel, {
                      key: tab.id,
                      value: tab.id
                    }, {
                      default: _withCtx(() => [
                        (_ctx.dataLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_dots_loader)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              (_ctx.selectedTabIndex == 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    (_ctx.tabDataLoading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                          _createVNode(_component_dots_loader)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_22, [
                                              _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                  _createElementVNode("div", _hoisted_25, [
                                                    _createElementVNode("div", _hoisted_26, [
                                                      _cache[101] || (_cache[101] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "System", -1)),
                                                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.systemObj?.systemName || 'N/A'), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_28, [
                                                      _cache[102] || (_cache[102] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Status", -1)),
                                                      (_ctx.systemObj.isActive && _ctx.systemObj.isActive==true)
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorStatusBg(1)])
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["text-xs", _ctx.colorStatusText(1)])
                                                            }, _toDisplayString(_ctx.getStatusLabel(1)), 3)
                                                          ], 2))
                                                        : ((_ctx.systemObj.isActive!=undefined && _ctx.systemObj.isActive==false)|| !_ctx.systemObj.isActive)
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 1,
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorStatusBg(2)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["text-xs", _ctx.colorStatusText(2)])
                                                              }, _toDisplayString(_ctx.getStatusLabel(2)), 3)
                                                            ], 2))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_29, "N/A"))
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_30, [
                                                  _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("div", _hoisted_32, [
                                                      _cache[103] || (_cache[103] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Category", -1)),
                                                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.systemObj?.systemCategory || 'N/A'), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_34, [
                                                    _createElementVNode("div", _hoisted_35, [
                                                      _cache[104] || (_cache[104] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Owner", -1)),
                                                      _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.systemOwner?.label || 'N/A'), 1)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_37, [
                                                  _createElementVNode("div", _hoisted_38, [
                                                    _cache[105] || (_cache[105] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Vendor", -1)),
                                                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.vendorData?.name || 'N/A'), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_40, [
                                                    _cache[106] || (_cache[106] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Vendor Category", -1)),
                                                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.vendorData?.vendorCategory || 'N/A'), 1)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_42, [
                                                  _createElementVNode("div", _hoisted_43, [
                                                    _cache[107] || (_cache[107] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Internet Facing", -1)),
                                                    _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.systemObj?.publicFacing == 1 ? 'Yes' : _ctx.systemObj?.publicFacing == 2 ? 'No' : 'N/A'), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_45, [
                                                    _cache[108] || (_cache[108] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "URL/IP", -1)),
                                                    _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.systemObj?.publicFacing == 1 ? _ctx.systemObj?.add:'N/A'), 1)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_47, [
                                                  _createElementVNode("div", _hoisted_48, [
                                                    _cache[109] || (_cache[109] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Model", -1)),
                                                    _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.systemObj?.hostingType || 'N/A'), 1)
                                                  ]),
                                                  (_ctx.systemObj?.hostingType =='On-premise')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                        _cache[110] || (_cache[110] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Location", -1)),
                                                        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.hostingProviderData?.label || 'N/A'), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.systemObj?.hostingType =='Data Center'||_ctx.systemObj?.hostingType =='Cloud')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                        _cache[111] || (_cache[111] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "State", -1)),
                                                        _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.systemObj?.state || 'N/A'), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                (_ctx.systemObj?.hostingType =='Data Center'||_ctx.systemObj?.hostingType =='Cloud')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                      _createElementVNode("div", _hoisted_55, [
                                                        _cache[112] || (_cache[112] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Country", -1)),
                                                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.systemObj?.country || 'N/A'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_57, [
                                                        _cache[113] || (_cache[113] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "City", -1)),
                                                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.systemObj?.city || 'N/A'), 1)
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_59, [
                                                  _createElementVNode("div", _hoisted_60, [
                                                    _cache[114] || (_cache[114] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Description", -1)),
                                                    _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.systemObj?.description || 'N/A'), 1)
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])),
                                    (_ctx.toolTipActive)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                          _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.selectedTabIndex == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                    (_ctx.tabDataLoading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                          _createVNode(_component_dots_loader)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                          _createElementVNode("div", _hoisted_66, [
                                            _createElementVNode("div", _hoisted_67, [
                                              _createElementVNode("table", {
                                                class: "table-fit-card table-header-table",
                                                style: _normalizeStyle(_ctx.tableResizeStyle)
                                              }, [
                                                _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", _hoisted_68, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHeaders, (column) => {
                                                      return (_openBlock(), _createElementBlock("th", {
                                                        scope: "col",
                                                        onClick: ($event: any) => (_ctx.onHeaderClick(column)),
                                                        class: _normalizeClass([_ctx.getHeaderProperties0('width',column), "bg-white capitalize resizable-th"]),
                                                        key: column,
                                                        style: _normalizeStyle(_ctx.columnStyle(column))
                                                      }, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center", _ctx.getHeaderProperties0('widthInner',column)])
                                                        }, [
                                                          (column == 'controlPriority')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString('Priority')))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.getHeaderProperties0('name',column)), 1)),
                                                          (column!='actionButtonForControls')
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 2,
                                                                class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                                              }, null, 2))
                                                            : _createCommentVNode("", true)
                                                        ], 2),
                                                        _createElementVNode("span", {
                                                          class: "column-resize-handle",
                                                          onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, column)), ["stop","prevent"])
                                                        }, null, 40, _hoisted_72)
                                                      ], 14, _hoisted_69))
                                                    }), 128))
                                                  ]),
                                                  (_ctx.showFilters)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_73, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeControlHeaders, (name, index) => {
                                                          return (_openBlock(), _createElementBlock("td", {
                                                            class: "bg-white",
                                                            key: index,
                                                            style: _normalizeStyle(_ctx.columnStyle(name))
                                                          }, [
                                                            (name == 'classificationType')
                                                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                  key: 0,
                                                                  class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                }, [
                                                                  _createElementVNode("option", {
                                                                    value: _ctx.allFilters.name,
                                                                    selected: "",
                                                                    disabled: "",
                                                                    hidden: ""
                                                                  }, "Select", 8, _hoisted_75),
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlTypeValues, (pair) => {
                                                                    return (_openBlock(), _createElementBlock("option", {
                                                                      class: "optionColors",
                                                                      key: pair,
                                                                      value: pair.id
                                                                    }, _toDisplayString(pair.value), 9, _hoisted_76))
                                                                  }), 128))
                                                                ], 10, _hoisted_74)), [
                                                                  [_vModelSelect, _ctx.allFilters[name]]
                                                                ])
                                                              : (name == 'controlPriority')
                                                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                    key: 1,
                                                                    class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                  }, [
                                                                    _createElementVNode("option", {
                                                                      value: _ctx.allFilters.name,
                                                                      selected: "",
                                                                      disabled: "",
                                                                      hidden: ""
                                                                    }, "Select", 8, _hoisted_78),
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (pair) => {
                                                                      return (_openBlock(), _createElementBlock("option", {
                                                                        class: "optionColors",
                                                                        key: pair,
                                                                        value: pair.value
                                                                      }, _toDisplayString(pair.key), 9, _hoisted_79))
                                                                    }), 128))
                                                                  ], 10, _hoisted_77)), [
                                                                    [_vModelSelect, _ctx.allFilters[name]]
                                                                  ])
                                                                : (name == 'controlFrequency')
                                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                      key: 2,
                                                                      class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                    }, [
                                                                      _createElementVNode("option", {
                                                                        value: _ctx.allFilters.name,
                                                                        selected: "",
                                                                        disabled: "",
                                                                        hidden: ""
                                                                      }, "Select", 8, _hoisted_81),
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (pair) => {
                                                                        return (_openBlock(), _createElementBlock("option", {
                                                                          class: "optionColors",
                                                                          key: pair,
                                                                          value: pair.value
                                                                        }, _toDisplayString(pair.key), 9, _hoisted_82))
                                                                      }), 128))
                                                                    ], 10, _hoisted_80)), [
                                                                      [_vModelSelect, _ctx.allFilters[name]]
                                                                    ])
                                                                  : (name == 'actionButtonForControls')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_83))
                                                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                        key: 4,
                                                                        type: "text",
                                                                        class: "searchForInputBoxStyling filter-font-size",
                                                                        placeholder: "Search",
                                                                        "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                      }, null, 8, _hoisted_84)), [
                                                                        [_vModelText, _ctx.allFilters[name]]
                                                                      ])
                                                          ], 4))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ], 4)
                                            ]),
                                            _createElementVNode("div", _hoisted_85, [
                                              _createElementVNode("table", {
                                                class: "table-fit-card",
                                                style: _normalizeStyle(_ctx.tableResizeStyle)
                                              }, [
                                                (_ctx.dataLoading == true)
                                                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_86, [
                                                      _createElementVNode("tr", _hoisted_87, [
                                                        _createElementVNode("td", {
                                                          class: "relative h-10",
                                                          colspan: _ctx.activeControlHeaders.length+1
                                                        }, [
                                                          _createElementVNode("div", _hoisted_89, [
                                                            _createVNode(_component_dots_loader)
                                                          ])
                                                        ], 8, _hoisted_88)
                                                      ])
                                                    ]))
                                                  : (_ctx.sortedDataActiveControls.length == 0)
                                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_90, [
                                                        _createElementVNode("tr", _hoisted_91, [
                                                          _createElementVNode("td", {
                                                            class: "relative h-10",
                                                            colspan: _ctx.activeControlHeaders.length
                                                          }, _cache[115] || (_cache[115] = [
                                                            _createElementVNode("div", { class: "flex justify-center" }, [
                                                              _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                            ], -1)
                                                          ]), 8, _hoisted_92)
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("tbody", _hoisted_93, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDataActiveControls, (controlObject, index) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: index,
                                                            class: "cursor-pointer rowHeight hoverEffectForCompleteRow"
                                                          }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHeaders, (column) => {
                                                              return (_openBlock(), _createElementBlock("td", {
                                                                scope: "col",
                                                                onClick: ($event: any) => (_ctx.showControlDetailsPopup(controlObject)),
                                                                onMouseout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doFalse())),
                                                                key: column,
                                                                class: _normalizeClass(_ctx.selectedTabIndex === 3 ? _ctx.getHeaderProperties2('width',column) : _ctx.getHeaderProperties0('width',column)),
                                                                style: _normalizeStyle(_ctx.columnStyle(column))
                                                              }, [
                                                                (column == 'classificationType')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                                                      _createElementVNode("div", null, _toDisplayString(_ctx.getControlTypeValue( controlObject['classificationType'] )), 1)
                                                                    ]))
                                                                  : (column == 'controlFrequency')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                                        _createElementVNode("div", null, _toDisplayString(_ctx.getFrequencyValue( controlObject['controlFrequency'] )), 1)
                                                                      ]))
                                                                    : (column == 'controlPriority')
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                                                          _createElementVNode("div", {
                                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorLabelBg(controlObject[column])])
                                                                          }, [
                                                                            _createElementVNode("div", {
                                                                              class: _normalizeClass(_ctx.colorLabelText(controlObject[column]))
                                                                            }, _toDisplayString(_ctx.getProirityLabel(controlObject[column])), 3)
                                                                          ], 2)
                                                                        ]))
                                                                      : (column === 'actionButtonForControls')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                                                            _createVNode(_component_Button, {
                                                                              class: "action-button",
                                                                              type: "button",
                                                                              icon: "pi pi-ellipsis-v",
                                                                              onClick: _withModifiers(($event: any) => (_ctx.actionButtonToggle($event, index)), ["stop"])
                                                                            }, null, 8, ["onClick"]),
                                                                            _createVNode(_component_Menu, {
                                                                              ref_for: true,
                                                                              ref: 'menu' + index,
                                                                              model: _ctx.actionButtonAtControl(controlObject),
                                                                              popup: true,
                                                                              appendTo: "body",
                                                                              class: "menuWidth"
                                                                            }, null, 8, ["model"])
                                                                          ]))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                                                            _createElementVNode("div", _hoisted_100, [
                                                                              _createElementVNode("p", {
                                                                                class: "fullText",
                                                                                onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, controlObject, 'text'))
                                                                              }, _toDisplayString(controlObject[column]), 41, _hoisted_101)
                                                                            ])
                                                                          ]))
                                                              ], 46, _hoisted_94))
                                                            }), 128))
                                                          ]))
                                                        }), 128))
                                                      ]))
                                              ], 4)
                                            ])
                                          ]),
                                          (_ctx.sortedDataActiveControls.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                _createVNode(_component_pagination, {
                                                  dynamicPagination: _ctx.dynamicPagination,
                                                  onCurrentPageUpdate: _ctx.paginationUpdations,
                                                  sortedData: _ctx.sortedDataActiveControls
                                                }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])),
                                    (_ctx.toolTipActive)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                          _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.selectedTabIndex == 2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                      (_ctx.tabDataLoading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                            _createVNode(_component_dots_loader)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                            _createElementVNode("div", _hoisted_107, [
                                              _createElementVNode("div", _hoisted_108, [
                                                _createElementVNode("table", {
                                                  class: "table-fit-card table-header-table",
                                                  style: _normalizeStyle(_ctx.tableResizeStyle)
                                                }, [
                                                  _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", _hoisted_109, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (column) => {
                                                        return (_openBlock(), _createElementBlock("th", {
                                                          scope: "col",
                                                          onClick: ($event: any) => (_ctx.onHeaderClick(column)),
                                                          class: _normalizeClass([_ctx.getHeaderProperties1('width',column), "bg-white capitalize resizable-th"]),
                                                          key: column,
                                                          style: _normalizeStyle(_ctx.columnStyle(column))
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(["flex items-center", _ctx.getHeaderProperties1('widthInner',column)])
                                                          }, [
                                                            (column == 'controlPriority')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString('Priority')))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_112, _toDisplayString(_ctx.getHeaderProperties1('name',column)), 1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                                            }, null, 2)
                                                          ], 2),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, column)), ["stop","prevent"])
                                                          }, null, 40, _hoisted_113)
                                                        ], 14, _hoisted_110))
                                                      }), 128))
                                                    ]),
                                                    (_ctx.showFilters)
                                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_114, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (name, index) => {
                                                            return (_openBlock(), _createElementBlock("td", {
                                                              class: "bg-white",
                                                              key: index,
                                                              style: _normalizeStyle(_ctx.columnStyle(name))
                                                            }, [
                                                              (name == 'classificationType')
                                                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                    key: 0,
                                                                    class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                  }, [
                                                                    _createElementVNode("option", {
                                                                      value: _ctx.allFilters.name,
                                                                      selected: "",
                                                                      disabled: "",
                                                                      hidden: ""
                                                                    }, "Select", 8, _hoisted_116),
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlTypeValues, (pair) => {
                                                                      return (_openBlock(), _createElementBlock("option", {
                                                                        class: "optionColors",
                                                                        key: pair,
                                                                        value: pair.id
                                                                      }, _toDisplayString(pair.value), 9, _hoisted_117))
                                                                    }), 128))
                                                                  ], 10, _hoisted_115)), [
                                                                    [_vModelSelect, _ctx.allFilters[name]]
                                                                  ])
                                                                : (name == 'controlPriority')
                                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                      key: 1,
                                                                      class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                    }, [
                                                                      _createElementVNode("option", {
                                                                        value: _ctx.allFilters.name,
                                                                        selected: "",
                                                                        disabled: "",
                                                                        hidden: ""
                                                                      }, "Select", 8, _hoisted_119),
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (pair) => {
                                                                        return (_openBlock(), _createElementBlock("option", {
                                                                          class: "optionColors",
                                                                          key: pair,
                                                                          value: pair.value
                                                                        }, _toDisplayString(pair.key), 9, _hoisted_120))
                                                                      }), 128))
                                                                    ], 10, _hoisted_118)), [
                                                                      [_vModelSelect, _ctx.allFilters[name]]
                                                                    ])
                                                                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                      key: 2,
                                                                      type: "text",
                                                                      class: "searchForInputBoxStyling filter-font-size",
                                                                      placeholder: "Search",
                                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                    }, null, 8, _hoisted_121)), [
                                                                      [_vModelText, _ctx.allFilters[name]]
                                                                    ])
                                                            ], 4))
                                                          }), 128))
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ], 4)
                                              ]),
                                              _createElementVNode("div", _hoisted_122, [
                                                _createElementVNode("table", {
                                                  class: "table-fit-card",
                                                  style: _normalizeStyle(_ctx.tableResizeStyle)
                                                }, [
                                                  (_ctx.dataLoading == true)
                                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_123, [
                                                        _createElementVNode("tr", _hoisted_124, [
                                                          _createElementVNode("td", {
                                                            class: "relative h-10",
                                                            colspan: _ctx.allControlHeaders.length + 1
                                                          }, [
                                                            _createElementVNode("div", _hoisted_126, [
                                                              _createVNode(_component_dots_loader)
                                                            ])
                                                          ], 8, _hoisted_125)
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.sortedDataAllControls.length == 0)
                                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_127, [
                                                        _createElementVNode("tr", _hoisted_128, [
                                                          _createElementVNode("td", {
                                                            class: "relative h-10",
                                                            colspan: _ctx.allControlHeaders.length
                                                          }, _cache[116] || (_cache[116] = [
                                                            _createElementVNode("div", { class: "flex justify-center" }, [
                                                              _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                            ], -1)
                                                          ]), 8, _hoisted_129)
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("tbody", _hoisted_130, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDataAllControls, (controlObject, index) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: index,
                                                            class: "cursor-pointer rowHeight hoverEffectForCompleteRow"
                                                          }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (column) => {
                                                              return (_openBlock(), _createElementBlock("td", {
                                                                scope: "col",
                                                                onClick: ($event: any) => (_ctx.showControlDetailsPopup(controlObject)),
                                                                onMouseout: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doFalse())),
                                                                key: column,
                                                                style: _normalizeStyle(_ctx.columnStyle(column))
                                                              }, [
                                                                (column == 'classificationType')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                                                      _createElementVNode("div", null, _toDisplayString(_ctx.getControlTypeValue( controlObject['classificationType'] )), 1)
                                                                    ]))
                                                                  : (column == 'controlPriority')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                                                        _createElementVNode("div", {
                                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorLabelBg(controlObject[column])])
                                                                        }, [
                                                                          _createElementVNode("div", {
                                                                            class: _normalizeClass(_ctx.colorLabelText(controlObject[column]))
                                                                          }, _toDisplayString(_ctx.getProirityLabel(controlObject[column])), 3)
                                                                        ], 2)
                                                                      ]))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                                                        _createElementVNode("div", _hoisted_135, [
                                                                          _createElementVNode("p", {
                                                                            class: "fullText",
                                                                            onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, controlObject, 'text'))
                                                                          }, _toDisplayString(controlObject[column]), 41, _hoisted_136)
                                                                        ])
                                                                      ]))
                                                              ], 44, _hoisted_131))
                                                            }), 128))
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                ], 4)
                                              ])
                                            ]),
                                            (_ctx.sortedDataAllControls.length > 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                                  _createVNode(_component_pagination, {
                                                    dynamicPagination: _ctx.dynamicPagination,
                                                    onCurrentPageUpdate: _ctx.paginationUpdations,
                                                    sortedData: _ctx.sortedDataAllControls
                                                  }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])),
                                      (_ctx.toolTipActive)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                              (_ctx.selectedTabIndex == 3)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                    (_ctx.tabDataLoading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                          _createVNode(_component_dots_loader)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                          _createElementVNode("div", _hoisted_142, [
                                            _createElementVNode("div", _hoisted_143, [
                                              _createElementVNode("table", {
                                                class: "table-fit-card table-header-table",
                                                style: _normalizeStyle(_ctx.tableResizeStyle)
                                              }, [
                                                _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", _hoisted_144, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHeaders, (column) => {
                                                      return (_openBlock(), _createElementBlock("th", {
                                                        scope: "col",
                                                        onClick: ($event: any) => (_ctx.onHeaderClick(column)),
                                                        class: _normalizeClass([_ctx.getHeaderProperties2('width',column), "bg-white capitalize resizable-th"]),
                                                        key: column,
                                                        style: _normalizeStyle(_ctx.columnStyle(column))
                                                      }, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center", _ctx.getHeaderProperties2('widthInner',column)])
                                                        }, [
                                                          (column == 'controlPriority')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_146, _toDisplayString('Priority')))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_147, _toDisplayString(_ctx.getHeaderProperties2('name',column)), 1)),
                                                          (column!='actionButtonForControls')
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 2,
                                                                class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                                              }, null, 2))
                                                            : _createCommentVNode("", true)
                                                        ], 2),
                                                        _createElementVNode("span", {
                                                          class: "column-resize-handle",
                                                          onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, column)), ["stop","prevent"])
                                                        }, null, 40, _hoisted_148)
                                                      ], 14, _hoisted_145))
                                                    }), 128))
                                                  ]),
                                                  (_ctx.showFilters)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_149, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.InactiveControlHeaders, (name, index) => {
                                                          return (_openBlock(), _createElementBlock("td", {
                                                            class: "bg-white",
                                                            key: index,
                                                            style: _normalizeStyle(_ctx.columnStyle(name))
                                                          }, [
                                                            (name == 'classificationType')
                                                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                  key: 0,
                                                                  class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                }, [
                                                                  _createElementVNode("option", {
                                                                    value: _ctx.allFilters.name,
                                                                    selected: "",
                                                                    disabled: "",
                                                                    hidden: ""
                                                                  }, "Select", 8, _hoisted_151),
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlTypeValues, (pair) => {
                                                                    return (_openBlock(), _createElementBlock("option", {
                                                                      class: "optionColors",
                                                                      key: pair,
                                                                      value: pair.id
                                                                    }, _toDisplayString(pair.value), 9, _hoisted_152))
                                                                  }), 128))
                                                                ], 10, _hoisted_150)), [
                                                                  [_vModelSelect, _ctx.allFilters[name]]
                                                                ])
                                                              : (name == 'controlPriority')
                                                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                    key: 1,
                                                                    class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                  }, [
                                                                    _createElementVNode("option", {
                                                                      value: _ctx.allFilters.name,
                                                                      selected: "",
                                                                      disabled: "",
                                                                      hidden: ""
                                                                    }, "Select", 8, _hoisted_154),
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (pair) => {
                                                                      return (_openBlock(), _createElementBlock("option", {
                                                                        class: "optionColors",
                                                                        key: pair,
                                                                        value: pair.value
                                                                      }, _toDisplayString(pair.key), 9, _hoisted_155))
                                                                    }), 128))
                                                                  ], 10, _hoisted_153)), [
                                                                    [_vModelSelect, _ctx.allFilters[name]]
                                                                  ])
                                                                : (name == 'controlFrequency')
                                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                      key: 2,
                                                                      class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                    }, [
                                                                      _createElementVNode("option", {
                                                                        value: _ctx.allFilters.name,
                                                                        selected: "",
                                                                        disabled: "",
                                                                        hidden: ""
                                                                      }, "Select", 8, _hoisted_157),
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (pair) => {
                                                                        return (_openBlock(), _createElementBlock("option", {
                                                                          class: "optionColors",
                                                                          key: pair,
                                                                          value: pair.value
                                                                        }, _toDisplayString(pair.key), 9, _hoisted_158))
                                                                      }), 128))
                                                                    ], 10, _hoisted_156)), [
                                                                      [_vModelSelect, _ctx.allFilters[name]]
                                                                    ])
                                                                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                      key: 3,
                                                                      type: "text",
                                                                      class: "searchForInputBoxStyling filter-font-size",
                                                                      placeholder: "Search",
                                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                                                    }, null, 8, _hoisted_159)), [
                                                                      [_vModelText, _ctx.allFilters[name]]
                                                                    ])
                                                          ], 4))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ], 4)
                                            ]),
                                            _createElementVNode("div", _hoisted_160, [
                                              _createElementVNode("table", {
                                                class: "table-fit-card",
                                                style: _normalizeStyle(_ctx.tableResizeStyle)
                                              }, [
                                                (_ctx.dataLoading == true)
                                                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_161, [
                                                      _createElementVNode("tr", _hoisted_162, [
                                                        _createElementVNode("td", {
                                                          class: "relative h-10",
                                                          colspan: _ctx.InactiveControlHeaders.length+1
                                                        }, [
                                                          _createElementVNode("div", _hoisted_164, [
                                                            _createVNode(_component_dots_loader)
                                                          ])
                                                        ], 8, _hoisted_163)
                                                      ])
                                                    ]))
                                                  : (_ctx.sortedDataActiveControls.length == 0)
                                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_165, [
                                                        _createElementVNode("tr", _hoisted_166, [
                                                          _createElementVNode("td", {
                                                            class: "relative h-10",
                                                            colspan: _ctx.InactiveControlHeaders.length
                                                          }, _cache[117] || (_cache[117] = [
                                                            _createElementVNode("div", { class: "flex justify-center" }, [
                                                              _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                            ], -1)
                                                          ]), 8, _hoisted_167)
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("tbody", _hoisted_168, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDataActiveControls, (controlObject, index) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: index,
                                                            class: "cursor-pointer rowHeight hoverEffectForCompleteRow"
                                                          }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHeaders, (column) => {
                                                              return (_openBlock(), _createElementBlock("td", {
                                                                scope: "col",
                                                                onClick: ($event: any) => (_ctx.showControlDetailsPopup(controlObject)),
                                                                onMouseout: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doFalse())),
                                                                key: column,
                                                                class: _normalizeClass(_ctx.selectedTabIndex === 3 ? _ctx.getHeaderProperties2('width',column) : _ctx.getHeaderProperties0('width',column)),
                                                                style: _normalizeStyle(_ctx.columnStyle(column))
                                                              }, [
                                                                (column == 'classificationType')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                                                      _createElementVNode("div", null, _toDisplayString(_ctx.getControlTypeValue( controlObject['classificationType'] )), 1)
                                                                    ]))
                                                                  : (column == 'controlFrequency')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                                                                        _createElementVNode("div", null, _toDisplayString(_ctx.getFrequencyValue( controlObject['controlFrequency'] )), 1)
                                                                      ]))
                                                                    : (column == 'controlPriority')
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                                                          _createElementVNode("div", {
                                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorLabelBg(controlObject[column])])
                                                                          }, [
                                                                            _createElementVNode("div", {
                                                                              class: _normalizeClass(_ctx.colorLabelText(controlObject[column]))
                                                                            }, _toDisplayString(_ctx.getProirityLabel(controlObject[column])), 3)
                                                                          ], 2)
                                                                        ]))
                                                                      : (column === 'actionButtonForControls')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                                                                            _createVNode(_component_Button, {
                                                                              class: "action-button",
                                                                              type: "button",
                                                                              icon: "pi pi-ellipsis-v",
                                                                              onClick: _withModifiers(($event: any) => (_ctx.actionButtonToggle($event, index)), ["stop"])
                                                                            }, null, 8, ["onClick"]),
                                                                            _createVNode(_component_Menu, {
                                                                              ref_for: true,
                                                                              ref: 'menu' + index,
                                                                              model: _ctx.actionButtonAtControl(controlObject),
                                                                              popup: true,
                                                                              appendTo: "body",
                                                                              class: "menuWidth"
                                                                            }, null, 8, ["model"])
                                                                          ]))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                                                            _createElementVNode("div", _hoisted_175, [
                                                                              _createElementVNode("p", {
                                                                                class: "fullText",
                                                                                onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, controlObject, 'text'))
                                                                              }, _toDisplayString(controlObject[column]), 41, _hoisted_176)
                                                                            ])
                                                                          ]))
                                                              ], 46, _hoisted_169))
                                                            }), 128))
                                                          ]))
                                                        }), 128))
                                                      ]))
                                              ], 4)
                                            ])
                                          ]),
                                          (_ctx.sortedDataActiveControls.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                                                _createVNode(_component_pagination, {
                                                  dynamicPagination: _ctx.dynamicPagination,
                                                  onCurrentPageUpdate: _ctx.paginationUpdations,
                                                  sortedData: _ctx.sortedDataActiveControls
                                                }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])),
                                    (_ctx.toolTipActive)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                          _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.selectedTabIndex == 4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                      (_ctx.tabDataLoading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                            _createVNode(_component_dots_loader)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_181, [
                                            _createElementVNode("div", _hoisted_182, [
                                              _cache[120] || (_cache[120] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "header" }, "History")
                                                ])
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_183, [
                                                (_ctx.newHistory)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: _normalizeClass(["filterButton w-24 flex taskEditButtons", _ctx.workLogObject?.[0] && Object.keys(_ctx.workLogObject[0]).includes('history') && _ctx.workLogObject[0].history?.length !== 0 ? 'btnprimary' : 'pointer-events-none']),
                                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortWorkLog()))
                                                    }, _cache[118] || (_cache[118] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_2,
                                                        class: "h-3 mr-2.5"
                                                      }, null, -1),
                                                      _createTextVNode(" Oldest ")
                                                    ]), 2))
                                                  : _createCommentVNode("", true),
                                                (!_ctx.newHistory)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 1,
                                                      class: "filterButton w-24 flex taskEditButtons",
                                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortWorkLog()))
                                                    }, _cache[119] || (_cache[119] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_2,
                                                        class: "h-3 mr-2.5 rotate-180"
                                                      }, null, -1),
                                                      _createTextVNode(" Newest ")
                                                    ])))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_184, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject[0]?.history, (work) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: work,
                                                  class: "bg-white py-4 mb-0.5 border-lightgrey border-b"
                                                }, [
                                                  _createElementVNode("div", _hoisted_185, [
                                                    (Object.keys(work).includes('activatedBy'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_186, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                      : (Object.keys(work).includes('activatedAt'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_187, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_188, [
                                                      _createElementVNode("div", _hoisted_189, [
                                                        (Object.keys(work).includes('activatedBy'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_190, _toDisplayString(work.name), 1))
                                                          : (Object.keys(work).includes('activatedAt'))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_191, _toDisplayString(work.name), 1))
                                                            : _createCommentVNode("", true),
                                                        (work.hasOwnProperty('currentControlOwner'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                                                              _createElementVNode("p", null, [
                                                                _cache[121] || (_cache[121] = _createTextVNode(_toDisplayString('Updated the ') + " ")),
                                                                _createElementVNode("b", null, _toDisplayString(work.clientUniqueId), 1),
                                                                _cache[122] || (_cache[122] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                                _createElementVNode("span", _hoisted_193, [
                                                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.activatedAt)), 1)
                                                                ])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_194, [
                                                                _cache[123] || (_cache[123] = _createTextVNode(_toDisplayString('Control Owner from ') + " ")),
                                                                _createElementVNode("b", null, _toDisplayString(_ctx.getControlOwnerName(work.previousControlOwner)), 1),
                                                                _cache[124] || (_cache[124] = _createTextVNode(" " + _toDisplayString(' to ') + " ")),
                                                                _createElementVNode("b", null, _toDisplayString(_ctx.getControlOwnerName(work.currentControlOwner)), 1)
                                                              ])
                                                            ]))
                                                          : (work.activatedBy && work.controlStatus==true && (work.hasOwnProperty('currentPriority') || !work.hasOwnProperty('currentFrequency')) && work.actionType==10301)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                                                _createElementVNode("p", null, [
                                                                  _cache[125] || (_cache[125] = _createTextVNode(_toDisplayString('Activated the '))),
                                                                  _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                                  _cache[126] || (_cache[126] = _createTextVNode(" " + _toDisplayString('on'))),
                                                                  _createElementVNode("span", _hoisted_196, [
                                                                    _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.activatedAt)), 1)
                                                                  ])
                                                                ])
                                                              ]))
                                                            : (work.createdBy && work.ClassificationType==3)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                                                  _createElementVNode("p", null, [
                                                                    _cache[127] || (_cache[127] = _createTextVNode(_toDisplayString('Created the '))),
                                                                    _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                                    _cache[128] || (_cache[128] = _createTextVNode(" " + _toDisplayString('on'))),
                                                                    _createElementVNode("span", _hoisted_198, [
                                                                      _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.createdAt)), 1)
                                                                    ])
                                                                  ])
                                                                ]))
                                                              : (work.activatedBy && (work.previousPriority)&&work.controlStatus!==false)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                                                    _createElementVNode("p", null, [
                                                                      _cache[129] || (_cache[129] = _createTextVNode(_toDisplayString('Updated the ') + " ")),
                                                                      _createElementVNode("b", null, _toDisplayString(work.clientUniqueId), 1),
                                                                      _cache[130] || (_cache[130] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                                      _createElementVNode("span", _hoisted_200, [
                                                                        _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.activatedAt)), 1)
                                                                      ])
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_201, [
                                                                      _cache[131] || (_cache[131] = _createTextVNode(_toDisplayString('from') + " ")),
                                                                      (work.previousPriority&&typeof work.previousPriority!='string')
                                                                        ? (_openBlock(), _createElementBlock("span", {
                                                                            key: 0,
                                                                            class: _normalizeClass([_ctx.colorLabelBg(work.previousPriority), "inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding"])
                                                                          }, [
                                                                            _createElementVNode("span", {
                                                                              class: _normalizeClass([_ctx.colorLabelText(work.previousPriority), "text-xs"])
                                                                            }, _toDisplayString(_ctx.getProirityLabel(work.previousPriority)), 3)
                                                                          ], 2))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_202, " N/A ")),
                                                                      _cache[132] || (_cache[132] = _createTextVNode(" " + _toDisplayString(' to ') + " ")),
                                                                      _createElementVNode("span", {
                                                                        class: _normalizeClass([_ctx.colorLabelBg(work.currentPriority), "inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding"])
                                                                      }, [
                                                                        _createElementVNode("span", {
                                                                          class: _normalizeClass([_ctx.colorLabelText(work.currentPriority), "text-xs"])
                                                                        }, _toDisplayString(_ctx.getProirityLabel(work.currentPriority)), 3)
                                                                      ], 2),
                                                                      _cache[133] || (_cache[133] = _createElementVNode("b", null, "in ActiveControls", -1))
                                                                    ])
                                                                  ]))
                                                                : (work.activatedBy && (work.previousPriority || work.currentPriority)&&work.controlStatus==false)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                                                      _createElementVNode("p", null, [
                                                                        _cache[134] || (_cache[134] = _createTextVNode(_toDisplayString('Updated the ') + " ")),
                                                                        _createElementVNode("b", null, _toDisplayString(work.clientUniqueId), 1),
                                                                        _cache[135] || (_cache[135] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                                        _createElementVNode("span", _hoisted_204, [
                                                                          _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.activatedAt)), 1)
                                                                        ])
                                                                      ]),
                                                                      _createElementVNode("div", _hoisted_205, [
                                                                        _cache[136] || (_cache[136] = _createTextVNode(_toDisplayString('from') + " ")),
                                                                        (work.previousPriority&&typeof work.previousPriority!='string')
                                                                          ? (_openBlock(), _createElementBlock("span", {
                                                                              key: 0,
                                                                              class: _normalizeClass([_ctx.colorLabelBg(work.previousPriority), "inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding"])
                                                                            }, [
                                                                              _createElementVNode("span", {
                                                                                class: _normalizeClass([_ctx.colorLabelText(work.previousPriority), "text-xs"])
                                                                              }, _toDisplayString(_ctx.getProirityLabel(work.previousPriority)), 3)
                                                                            ], 2))
                                                                          : (_openBlock(), _createElementBlock("span", _hoisted_206, " N/A ")),
                                                                        _cache[137] || (_cache[137] = _createTextVNode(" " + _toDisplayString(' to ') + " ")),
                                                                        _createElementVNode("span", {
                                                                          class: _normalizeClass([_ctx.colorLabelBg(work.currentPriority), "inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding"])
                                                                        }, [
                                                                          _createElementVNode("span", {
                                                                            class: _normalizeClass([_ctx.colorLabelText(work.currentPriority), "text-xs"])
                                                                          }, _toDisplayString(_ctx.getProirityLabel(work.currentPriority)), 3)
                                                                        ], 2),
                                                                        _cache[138] || (_cache[138] = _createElementVNode("b", null, "in InactiveControls", -1))
                                                                      ])
                                                                    ]))
                                                                  : (work.activatedBy&&(work.previousFrequency || work.currentFrequency))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                                                                        _createElementVNode("p", null, [
                                                                          _cache[139] || (_cache[139] = _createTextVNode(_toDisplayString('Updated the ') + " ")),
                                                                          _createElementVNode("b", null, _toDisplayString(work.clientUniqueId), 1),
                                                                          _cache[140] || (_cache[140] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                                          _createElementVNode("span", _hoisted_208, [
                                                                            _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.activatedAt)), 1)
                                                                          ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_209, [
                                                                          _cache[141] || (_cache[141] = _createTextVNode(_toDisplayString('from') + " ")),
                                                                          _createElementVNode("span", null, [
                                                                            _createElementVNode("b", null, _toDisplayString(_ctx.getFrequencyValue(work.previousFrequency)), 1)
                                                                          ]),
                                                                          _cache[142] || (_cache[142] = _createTextVNode(" " + _toDisplayString(' to ') + " ")),
                                                                          _createElementVNode("span", null, [
                                                                            _createElementVNode("b", null, _toDisplayString(_ctx.getFrequencyValue(work.currentFrequency)), 1)
                                                                          ])
                                                                        ])
                                                                      ]))
                                                                    : (work.activatedBy&&work.actionType==10302&&work.controlStatus==false)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                                                          _createElementVNode("p", null, [
                                                                            _cache[143] || (_cache[143] = _createTextVNode(_toDisplayString('Activating the '))),
                                                                            _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                                            _cache[144] || (_cache[144] = _createTextVNode(" " + _toDisplayString('on'))),
                                                                            _createElementVNode("span", _hoisted_211, [
                                                                              _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                                            ])
                                                                          ])
                                                                        ]))
                                                                      : (work.activatedBy&&work.actionType==10302&&work.controlStatus==true)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                                                            _createElementVNode("p", null, [
                                                                              _cache[145] || (_cache[145] = _createTextVNode(_toDisplayString('Activated the '))),
                                                                              _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                                              _cache[146] || (_cache[146] = _createTextVNode(" " + _toDisplayString('on'))),
                                                                              _createElementVNode("span", _hoisted_213, [
                                                                                _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                                              ])
                                                                            ])
                                                                          ]))
                                                                        : (work.activatedBy&&work.actionType==10301&&work.controlStatus==true)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                                                                              _createElementVNode("p", null, [
                                                                                _cache[147] || (_cache[147] = _createTextVNode(_toDisplayString('Activating the '))),
                                                                                _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                                                _cache[148] || (_cache[148] = _createTextVNode(" " + _toDisplayString('on'))),
                                                                                _createElementVNode("span", _hoisted_215, [
                                                                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                                                ])
                                                                              ])
                                                                            ]))
                                                                          : (work.activatedBy&&work.actionType==10303 && work.justification!='')
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                                                                                _createElementVNode("p", null, [
                                                                                  _cache[149] || (_cache[149] = _createTextVNode(_toDisplayString('Deactivated the '))),
                                                                                  _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                                                  _cache[150] || (_cache[150] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                                                  _createElementVNode("span", _hoisted_217, [
                                                                                    _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                                                  ])
                                                                                ])
                                                                              ]))
                                                                            : (work.updatedBy&&work.updatedIn=='DeactivatedControls'&&work.actionType==10302)
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                                                                                  _createElementVNode("p", null, [
                                                                                    _cache[151] || (_cache[151] = _createTextVNode(_toDisplayString('updated the '))),
                                                                                    _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                                                    _cache[152] || (_cache[152] = _createTextVNode(_toDisplayString(' in Inactive at'))),
                                                                                    _createElementVNode("span", _hoisted_219, [
                                                                                      _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                                                    ])
                                                                                  ])
                                                                                ]))
                                                                              : (work.updatedBy&&work.updatedIn=='ActivatedControls'&&work.actionType==10303)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                                                                                    _createElementVNode("p", null, [
                                                                                      _cache[153] || (_cache[153] = _createTextVNode(_toDisplayString('Activated the '))),
                                                                                      _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId} `), 1),
                                                                                      _cache[154] || (_cache[154] = _createTextVNode(_toDisplayString('on'))),
                                                                                      _createElementVNode("span", _hoisted_221, [
                                                                                        _createElementVNode("b", null, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                                                      ])
                                                                                    ])
                                                                                  ]))
                                                                                : _createCommentVNode("", true)
                                                      ]),
                                                      (work.activatedBy&&work.actionType==10303 && work.justification!='')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                                                            _cache[155] || (_cache[155] = _createElementVNode("b", null, "Justification:", -1)),
                                                            _createElementVNode("span", _hoisted_223, _toDisplayString(`${work.justification}`), 1)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ]))
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ], 2),
    (_ctx.customPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.customPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_224, [
              (_ctx.customControlObject != undefined && _ctx.customControlObject.classificationType == 3 )
                ? (_openBlock(), _createElementBlock("h1", _hoisted_225, _toDisplayString(_ctx.customControlObject.controlTitle), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_226, [
                    (_ctx.addpopup==false)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_227, _toDisplayString(_ctx.customControlObject.controlTitle || 'N/A'), 1))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_228, "Control"))
                  ])),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onCancelbtnCustom('close')))
              }, _cache[156] || (_cache[156] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_229, [
              _createElementVNode("div", _hoisted_230, [
                _createElementVNode("fieldset", {
                  disabled: _ctx.customControlObject._id
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_232, [
                      _createElementVNode("div", _hoisted_233, [
                        (_ctx.addpopup==true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                              _createElementVNode("div", _hoisted_235, [
                                _cache[157] || (_cache[157] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlTitle.$error
                                        }]),
                                  placeholder: "Title",
                                  onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.customControlObject.controlTitle.$touch())),
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customControlObject.controlTitle) = $event))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlTitle,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.customControlObject.controlTitle.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
                                      (_ctx.v$.customControlObject.controlTitle.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_237, "Required"))
                                        : (_ctx.v$.customControlObject.controlTitle && _ctx.v$.customControlObject.controlTitle.restrictCharacters100.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_238, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_239, [
                          _createTextVNode(_toDisplayString() + " ", 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[158] || (_cache[158] = _createElementVNode("label", { class: "controllabel" }, "Frequency", -1)),
                            (_ctx.addpopup==false && (_ctx.selectedTabIndex!=1|| _ctx.selectedTabIndex==1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_240, _toDisplayString(_ctx.dbFrequency.find(item => item.value === _ctx.customControlObject.controlFrequency)?.key ?? 'N/A'), 1))
                              : (_openBlock(), _createBlock(_component_Select, {
                                  key: 1,
                                  modelValue: _ctx.customControlObject.controlFrequency,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customControlObject.controlFrequency) = $event)),
                                  options: _ctx.dbFrequency,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlFrequency.$error,
                                            'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlFrequency === '',
                                        }])
                                }, null, 8, ["modelValue", "options", "class"])),
                            (_ctx.v$.customControlObject.controlFrequency.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                                  (_ctx.v$.customControlObject.controlFrequency.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_242, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[159] || (_cache[159] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                            (_ctx.addpopup==false && (_ctx.selectedTabIndex!=1|| _ctx.selectedTabIndex==1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                  (_ctx.customControlObject.controlPriority && typeof _ctx.customControlObject.controlPriority === 'number')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.customControlObject.controlPriority)])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.customControlObject.controlPriority)])
                                        }, _toDisplayString(_ctx.getProirityLabel(_ctx.customControlObject.controlPriority)), 3)
                                      ], 2))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_244, "N/A"))
                                ]))
                              : (_openBlock(), _createBlock(_component_Select, {
                                  key: 1,
                                  modelValue: _ctx.customControlObject.controlPriority,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.customControlObject.controlPriority) = $event)),
                                  options: _ctx.dbPriority,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlPriority.$error,
                                            'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlPriority === '',
                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.customControlObject.controlPriority !== ''
                                        }])
                                }, null, 8, ["modelValue", "options", "class"])),
                            (_ctx.v$.customControlObject.controlPriority.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                                  (_ctx.v$.customControlObject.controlPriority.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_246, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_247, [
                          _createElementVNode("div", _hoisted_248, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[160] || (_cache[160] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_249, _toDisplayString(_ctx.customControlObject.clientUniqueId ? _ctx.customControlObject.clientUniqueId : _ctx.customControlObject.controlNumber || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "text",
                                    class: "inputboxstyling mt-2 disiableState",
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.customControlObject.controlNumber) = $event)),
                                    onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.customControlObject.controlNumber.$touch())),
                                    placeholder: "Number",
                                    disabled: ""
                                  }, null, 544)), [
                                    [
                                      _vModelText,
                                      _ctx.customControlObject.controlNumber,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12 pl-4", {'topspace': _ctx.addpopup}])
                            }, [
                              _createElementVNode("div", null, [
                                _cache[161] || (_cache[161] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                                _createElementVNode("div", null, [
                                  (_ctx.addpopup==false)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_250, _toDisplayString(_ctx.customControlObject.controlType || 'N/A'), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_251, [
                                        _createVNode(_component_AutoComplete, {
                                          modelValue: _ctx.customControlObject.controlType,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customControlObject.controlType) = $event)),
                                          suggestions: _ctx.filteredControlTypeOptions,
                                          onComplete: _ctx.asyncFindControlType,
                                          field: "label",
                                          forceSelection: true,
                                          placeholder: "Category",
                                          class: "p-inputtext-sm systemsstyling mt-2"
                                        }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                      ])),
                                  (_ctx.v$.customControlObject.controlType.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                        (_ctx.v$.customControlObject.controlType && _ctx.v$.customControlObject.controlType.restrictCharacters300.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_253, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_254, [
                          _createElementVNode("div", _hoisted_255, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[162] || (_cache[162] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_256, _toDisplayString(_ctx.customControlObject.controlFamily || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_257, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customControlObject.controlFamily,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.customControlObject.controlFamily) = $event)),
                                      suggestions: _ctx.filteredControlFamilyOptions,
                                      onComplete: _ctx.asyncFindControlFamily,
                                      field: "label",
                                      forceSelection: true,
                                      placeholder: "Control Family",
                                      class: "p-inputtext-sm systemsstyling mt-2"
                                    }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                  ]))
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-3/6 leftspacing", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[163] || (_cache[163] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_258, _toDisplayString(_ctx.customControlObject.controlClass || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_259, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customControlObject.controlClass,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.customControlObject.controlClass) = $event)),
                                      suggestions: _ctx.filteredControlClassOptions,
                                      onComplete: _ctx.asyncFindControlClass,
                                      field: "label",
                                      forceSelection: true,
                                      placeholder: "Control Class",
                                      class: "p-inputtext-sm systemsstyling mt-2"
                                    }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                  ])),
                              (_ctx.v$.customControlObject.controlClass.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                                    (_ctx.v$.customControlObject.controlClass && _ctx.v$.customControlObject.controlClass.restrictCharacters300.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_261, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 8, _hoisted_231),
                (_ctx.selectedTabIndex != 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                      _createElementVNode("div", _hoisted_263, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_264, [
                            _cache[164] || (_cache[164] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.controlOwnerSelection,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.controlOwnerSelection) = $event)),
                              suggestions: _ctx.filteredControlOwnerOptions,
                              onComplete: _ctx.asyncFindControlOwner,
                              onItemSelect: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onControlOwnerPicked($event, _ctx.customControlObject))),
                              optionLabel: "label",
                              field: "label",
                              forceSelection: true,
                              invalid: _ctx.addpopup && _ctx.v$.customControlObject.controlOwner.$error,
                              placeholder: "Please select one",
                              class: "p-inputtext-sm systemsstyling mt-2 w-full"
                            }, null, 8, ["modelValue", "suggestions", "onComplete", "invalid"]),
                            (_ctx.addpopup && _ctx.v$.customControlObject.controlOwner.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
                                  (_ctx.v$.customControlObject.controlOwner.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_266, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("fieldset", {
                  disabled: _ctx.customControlObject._id
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_268, [
                      _createElementVNode("div", _hoisted_269, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_270, [
                            _cache[165] || (_cache[165] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_271, _toDisplayString(_ctx.customControlObject.Description || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.Description.$error
                                        }]),
                                  placeholder: "Description",
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.customControlObject.Description) = $event)),
                                  onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.v$.customControlObject.Description.$touch()))
                                }, "                                    ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.Description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.Description.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_272, [
                                  (_ctx.v$.customControlObject.Description && _ctx.v$.customControlObject.Description.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_273, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_274, [
                            _cache[166] || (_cache[166] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_275, _toDisplayString(_ctx.customControlObject.controlMaintenanceTask || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlMaintenanceTask.$error
                                        }]),
                                  placeholder: "Tasks",
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.customControlObject.controlMaintenanceTask) = $event)),
                                  onInput: _cache[26] || (_cache[26] = ($event: any) => (_ctx.v$.customControlObject.controlMaintenanceTask.$touch()))
                                }, "                                    ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlMaintenanceTask,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlMaintenanceTask.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_276, [
                                  (_ctx.v$.customControlObject.controlMaintenanceTask && _ctx.v$.customControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_277, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_278, [
                            _cache[167] || (_cache[167] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_279, _toDisplayString(_ctx.customControlObject.controlPolicies || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlPolicies.$error
                                        }]),
                                  placeholder: "Policies",
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.customControlObject.controlPolicies) = $event)),
                                  onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.v$.customControlObject.controlPolicies.$touch()))
                                }, "                                    ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlPolicies,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlPolicies.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_280, [
                                  (_ctx.v$.customControlObject.controlPolicies && _ctx.v$.customControlObject.controlPolicies.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_281, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_282, [
                            _cache[168] || (_cache[168] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_283, _toDisplayString(_ctx.customControlObject.controlGuidance || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlGuidance.$error
                                        }]),
                                  placeholder: "Guidance",
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.customControlObject.controlGuidance) = $event)),
                                  onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.v$.customControlObject.controlGuidance.$touch()))
                                }, "                                    ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlGuidance,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlGuidance.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_284, [
                                  (_ctx.v$.customControlObject.controlGuidance && _ctx.v$.customControlObject.controlGuidance.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_285, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addpopup}])
                        }, [
                          _cache[169] || (_cache[169] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                          (_ctx.addpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_286, _toDisplayString(_ctx.customControlObject.controlOptionFrameWork || 'N/A'), 1))
                            : (_openBlock(), _createBlock(_component_Select, {
                                key: 1,
                                modelValue: _ctx.customControlObject.controlOptionFrameWork,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.customControlObject.controlOptionFrameWork) = $event)),
                                options: _ctx.frameWorksList,
                                onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.getFrameworkControls(_ctx.customControlObject.controlOptionFrameWork))),
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                        'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork === '',
                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork !== ''
                                    }])
                              }, null, 8, ["modelValue", "options", "class"]))
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addpopup}])
                        }, [
                          _cache[170] || (_cache[170] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                          (_ctx.addpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_287, _toDisplayString(_ctx.customControlObject.frameworkControls || 'N/A'), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_288, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.customControlObject.frameworkControls,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.customControlObject.frameworkControls) = $event)),
                                  options: _ctx.frameworkControls,
                                  optionValue: "value",
                                  optionLabel: "label",
                                  disabled: _ctx.customControlObject.controlOptionFrameWork=='',
                                  placeholder: "Please select one",
                                  appendTo: "self",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.customControlObject.controlOptionFrameWork !== ''
                                            }])
                                }, null, 8, ["modelValue", "options", "disabled", "class"])
                              ]))
                        ], 2)
                      ])
                    ])
                  ])
                ], 8, _hoisted_267)
              ]),
              (_ctx.customPopup=true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_289, [
                    _cache[171] || (_cache[171] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    (!_ctx.customControlObject._id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_290, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onCancelbtnCustom('cancel')))
                          }, "Reset", 10, _hoisted_291),
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.saveCustomControl(_ctx.customControlObject)))
                          }, "Save", 10, _hoisted_292)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedTabIndex == 1 && _ctx.customControlObject._id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_293, [
                    _cache[172] || (_cache[172] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_294, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary", _ctx.controlOwnerChanged ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        type: "button",
                        disabled: !_ctx.controlOwnerChanged,
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.onExistingControlOwnerSelect()))
                      }, "Update", 10, _hoisted_295)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedTabIndex == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_296, [
                    _cache[173] || (_cache[173] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_297, [
                      _createElementVNode("button", {
                        class: "btnprimary",
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.mapTheSelectedControlsToSystem(10301)))
                      }, "Active", 8, _hoisted_298)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedTabIndex == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_299, [
                    _cache[174] || (_cache[174] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_300, [
                      (_ctx.customControlObject._id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.controlOwnerChanged ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            type: "button",
                            disabled: !_ctx.controlOwnerChanged,
                            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onExistingControlOwnerSelect()))
                          }, "Update", 10, _hoisted_301))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btnprimary",
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.active(_ctx.customControlObject)))
                      }, "Active")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.clonePopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.clonePopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_302, [
              (_ctx.customCloneControlObject != undefined && _ctx.customCloneControlObject.classificationType == 3 )
                ? (_openBlock(), _createElementBlock("h1", _hoisted_303, _toDisplayString(_ctx.customCloneControlObject.controlTitle), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_304, [
                    (_ctx.addpopup==false)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_305, _toDisplayString(_ctx.customCloneControlObject.controlTitle || 'N/A'), 1))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_306, "Clone Control"))
                  ])),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onCancelbtnCustom('close')))
              }, _cache[175] || (_cache[175] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_307, [
              _createElementVNode("div", _hoisted_308, [
                _createElementVNode("fieldset", {
                  disabled: _ctx.customCloneControlObject._id
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_310, [
                      _createElementVNode("div", _hoisted_311, [
                        (_ctx.addpopup==true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_312, [
                              _createElementVNode("div", _hoisted_313, [
                                _cache[176] || (_cache[176] = _createElementVNode("label", { class: "controllabel" }, "Source Control", -1)),
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.customCloneControlObject.source,
                                  "onUpdate:modelValue": [
                                    _cache[41] || (_cache[41] = ($event: any) => ((_ctx.customCloneControlObject.source) = $event)),
                                    _ctx.checkTitleCleared
                                  ],
                                  suggestions: _ctx.filteredICOptions,
                                  onComplete: _ctx.asyncFindInternalControls,
                                  onItemSelect: _ctx.bindOtherFields,
                                  onClear: _ctx.resetCloneControlFields,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  field: "label",
                                  panelClass: "clone-popup-panel",
                                  forceSelection: true,
                                  placeholder: "Source",
                                  class: _normalizeClass(["p-inputtext-sm custom-multiselect systemsstyling mt-2", { 'p-invalid': _ctx.v$.customCloneControlObject.source.$error }])
                                }, null, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "onClear", "onUpdate:modelValue", "class"]),
                                (_ctx.v$.customCloneControlObject.source.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                                      (_ctx.v$.customCloneControlObject.source.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_315, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.addpopup==true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_316, [
                              _createElementVNode("div", _hoisted_317, [
                                _cache[177] || (_cache[177] = _createElementVNode("label", { class: "controllabel" }, "Control Title", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
                                        'is-invalid': _ctx.v$.customCloneControlObject.controlTitle.$error,
                                        'disabled-textarea': !_ctx.customCloneControlObject.source
                                    }]),
                                  placeholder: "Control Title",
                                  disabled: !_ctx.customCloneControlObject.source,
                                  onInput: _cache[42] || (_cache[42] = ($event: any) => (_ctx.v$.customCloneControlObject.controlTitle.$touch())),
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.customCloneControlObject.controlTitle) = $event))
                                }, null, 42, _hoisted_318), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlTitle,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.customCloneControlObject.controlTitle.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_319, [
                                      (_ctx.v$.customCloneControlObject.controlTitle.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_320, "Required"))
                                        : (_ctx.v$.customCloneControlObject.controlTitle && _ctx.v$.customCloneControlObject.controlTitle.restrictCharacters100.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_321, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_322, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[178] || (_cache[178] = _createElementVNode("label", { class: "controllabel text-xs" }, "Frequency", -1)),
                            (_ctx.addpopup==false && (_ctx.selectedTabIndex!=1|| _ctx.selectedTabIndex==1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_323, _toDisplayString(_ctx.dbFrequency.find((item) => item.value === _ctx.customCloneControlObject.controlFrequency)?.key ?? 'N/A'), 1))
                              : (_openBlock(), _createBlock(_component_Select, {
                                  key: 1,
                                  modelValue: _ctx.customCloneControlObject.controlFrequency,
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.customCloneControlObject.controlFrequency) = $event)),
                                  options: _ctx.dbFrequency,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  disabled: !_ctx.customCloneControlObject.source,
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                        'is-invalid': _ctx.v$.customCloneControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlFrequency === '',
                                    }])
                                }, null, 8, ["modelValue", "options", "disabled", "class"])),
                            (_ctx.v$.customCloneControlObject.controlFrequency.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_324, [
                                  (_ctx.v$.customCloneControlObject.controlFrequency.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_325, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[179] || (_cache[179] = _createElementVNode("label", { class: "controllabel text-xs" }, "Priority", -1)),
                            (_ctx.addpopup==false && (_ctx.selectedTabIndex!=1|| _ctx.selectedTabIndex==1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_326, [
                                  (_ctx.customCloneControlObject.controlPriority && typeof _ctx.customCloneControlObject.controlPriority === 'number')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.customCloneControlObject.controlPriority)])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.customCloneControlObject.controlPriority)])
                                        }, _toDisplayString(_ctx.getProirityLabel(_ctx.customCloneControlObject.controlPriority)), 3)
                                      ], 2))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_327, "N/A"))
                                ]))
                              : (_openBlock(), _createBlock(_component_Select, {
                                  key: 1,
                                  modelValue: _ctx.customCloneControlObject.controlPriority,
                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.customCloneControlObject.controlPriority) = $event)),
                                  options: _ctx.dbPriority,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  disabled: !_ctx.customCloneControlObject.source,
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                        'is-invalid': _ctx.v$.customCloneControlObject.controlPriority.$error,
                                        'inputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlPriority === '',
                                    }])
                                }, null, 8, ["modelValue", "options", "disabled", "class"])),
                            (_ctx.v$.customCloneControlObject.controlPriority.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_328, [
                                  (_ctx.v$.customCloneControlObject.controlPriority.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_329, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_330, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                          }, [
                            _cache[180] || (_cache[180] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_331, _toDisplayString(_ctx.customCloneControlObject.clientUniqueId ? _ctx.customCloneControlObject.clientUniqueId:_ctx.customCloneControlObject.controlNumber|| 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  type: "text",
                                  class: "inputboxstyling mt-2 disiableState",
                                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.customCloneControlObject.controlNumber) = $event)),
                                  placeholder: "Number",
                                  disabled: ""
                                }, null, 512)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlNumber,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-6/12 leftspacing", {'topspace': _ctx.addpopup}])
                          }, [
                            _createElementVNode("div", null, [
                              _cache[181] || (_cache[181] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                              _createElementVNode("div", null, [
                                (_ctx.addpopup==false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_332, _toDisplayString(_ctx.customCloneControlObject.controlType || 'N/A'), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_333, [
                                      _createVNode(_component_AutoComplete, {
                                        modelValue: _ctx.customCloneControlObject.controlType,
                                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.customCloneControlObject.controlType) = $event)),
                                        suggestions: _ctx.filteredControlTypeOptions,
                                        onComplete: _ctx.asyncFindControlType,
                                        field: "label",
                                        forceSelection: true,
                                        placeholder: "Category",
                                        disabled: !_ctx.customCloneControlObject.source,
                                        class: "p-inputtext-sm systemsstyling mt-2"
                                      }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                                    ])),
                                (_ctx.v$.customCloneControlObject.controlType.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_334, [
                                      (_ctx.v$.customCloneControlObject.controlType && _ctx.v$.customCloneControlObject.controlType.restrictCharacters300.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_335, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_336, [
                          _createElementVNode("div", _hoisted_337, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[182] || (_cache[182] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_338, _toDisplayString(_ctx.customCloneControlObject.controlFamily || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_339, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customCloneControlObject.controlFamily,
                                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.customCloneControlObject.controlFamily) = $event)),
                                      suggestions: _ctx.filteredControlFamilyOptions,
                                      onComplete: _ctx.asyncFindControlFamily,
                                      field: "label",
                                      forceSelection: true,
                                      disabled: !_ctx.customCloneControlObject.source,
                                      placeholder: "Control Family",
                                      class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2", { 'p-invalid': _ctx.v$.customCloneControlObject.controlFamily.$error }])
                                    }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"]),
                                    (_ctx.v$.customCloneControlObject.controlFamily.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_340, [
                                          (_ctx.v$.customCloneControlObject.controlFamily && _ctx.v$.customCloneControlObject.controlFamily.restrictCharacters30.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_341, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-3/6 leftspacing", {'topspace': _ctx.addpopup}])
                            }, [
                              _cache[183] || (_cache[183] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                              (_ctx.addpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_342, _toDisplayString(_ctx.customCloneControlObject.controlClass || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_343, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.customCloneControlObject.controlClass,
                                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.customCloneControlObject.controlClass) = $event)),
                                      suggestions: _ctx.filteredControlClassOptions,
                                      onComplete: _ctx.asyncFindControlClass,
                                      field: "label",
                                      disabled: !_ctx.customCloneControlObject.source,
                                      forceSelection: true,
                                      placeholder: "Control Class",
                                      class: "p-inputtext-sm systemsstyling mt-2"
                                    }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                                  ])),
                              (_ctx.v$.customCloneControlObject.controlClass.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_344, [
                                    (_ctx.v$.customCloneControlObject.controlClass && _ctx.v$.customCloneControlObject.controlClass.restrictCharacters300.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_345, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_346, [
                            _cache[184] || (_cache[184] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.controlOwnerSelection,
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.controlOwnerSelection) = $event)),
                              suggestions: _ctx.filteredControlOwnerOptions,
                              onComplete: _ctx.asyncFindControlOwner,
                              onItemSelect: _cache[51] || (_cache[51] = ($event: any) => (_ctx.onControlOwnerPicked($event, _ctx.customCloneControlObject))),
                              optionLabel: "label",
                              field: "label",
                              disabled: !_ctx.customCloneControlObject.source,
                              forceSelection: true,
                              invalid: _ctx.v$.customCloneControlObject.controlOwner.$error,
                              placeholder: "Please select one",
                              class: "p-inputtext-sm systemsstyling mt-2 w-full"
                            }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled", "invalid"]),
                            (_ctx.v$.customCloneControlObject.controlOwner.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_347, [
                                  (_ctx.v$.customCloneControlObject.controlOwner.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_348, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_349, [
                            _cache[185] || (_cache[185] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_350, _toDisplayString(_ctx.customCloneControlObject.Description || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customCloneControlObject.Description.$error,
                                            'disabled-textarea': !_ctx.customCloneControlObject.source
                                        }]),
                                  placeholder: "Description",
                                  disabled: !_ctx.customCloneControlObject.source,
                                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.customCloneControlObject.Description) = $event))
                                }, "                                    ", 10, _hoisted_351)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.Description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customCloneControlObject.Description.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_352, [
                                  (_ctx.v$.customCloneControlObject.Description && _ctx.v$.customCloneControlObject.Description.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_353, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_354, [
                            _cache[186] || (_cache[186] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_355, _toDisplayString(_ctx.customCloneControlObject.controlMaintenanceTask || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customCloneControlObject.controlMaintenanceTask.$error,
                                            'disabled-textarea': !_ctx.customCloneControlObject.source
                                        }]),
                                  placeholder: "Tasks",
                                  disabled: !_ctx.customCloneControlObject.source,
                                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.customCloneControlObject.controlMaintenanceTask) = $event))
                                }, "                                    ", 10, _hoisted_356)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlMaintenanceTask,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customCloneControlObject.controlMaintenanceTask.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_357, [
                                  (_ctx.v$.customCloneControlObject.controlMaintenanceTask && _ctx.v$.customCloneControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_358, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_359, [
                            _cache[187] || (_cache[187] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_360, _toDisplayString(_ctx.customCloneControlObject.controlPolicies || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customCloneControlObject.controlPolicies.$error,
                                            'disabled-textarea': !_ctx.customCloneControlObject.source
                                        }]),
                                  placeholder: "Policies",
                                  disabled: !_ctx.customCloneControlObject.source,
                                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.customCloneControlObject.controlPolicies) = $event)),
                                  onInput: _cache[55] || (_cache[55] = ($event: any) => (_ctx.v$.customCloneControlObject.controlPolicies.$touch()))
                                }, "                                    ", 42, _hoisted_361)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlPolicies,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customCloneControlObject.controlPolicies.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_362, [
                                  (_ctx.v$.customCloneControlObject.controlPolicies && _ctx.v$.customCloneControlObject.controlPolicies.restrictCharacters300.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_363, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_364, [
                            _cache[188] || (_cache[188] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                            (_ctx.addpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_365, _toDisplayString(_ctx.customCloneControlObject.controlGuidance || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customCloneControlObject.controlGuidance.$error,
                                            'disabled-textarea': !_ctx.customCloneControlObject.source
                                        }]),
                                  placeholder: "Guidance",
                                  disabled: !_ctx.customCloneControlObject.source,
                                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.customCloneControlObject.controlGuidance) = $event)),
                                  onInput: _cache[57] || (_cache[57] = ($event: any) => (_ctx.v$.customCloneControlObject.controlGuidance.$touch()))
                                }, "                                    ", 42, _hoisted_366)), [
                                  [
                                    _vModelText,
                                    _ctx.customCloneControlObject.controlGuidance,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customCloneControlObject.controlGuidance.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_367, [
                                  (_ctx.v$.customCloneControlObject.controlGuidance && _ctx.v$.customCloneControlObject.controlGuidance.restrictCharacters1000.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_368, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addpopup}])
                        }, [
                          _cache[189] || (_cache[189] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                          (_ctx.addpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_369, _toDisplayString(_ctx.customCloneControlObject.controlOptionFrameWork || 'N/A'), 1))
                            : (_openBlock(), _createBlock(_component_Select, {
                                key: 1,
                                modelValue: _ctx.customCloneControlObject.controlOptionFrameWork,
                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.customCloneControlObject.controlOptionFrameWork) = $event)),
                                options: _ctx.frameWorksList,
                                disabled: !_ctx.customCloneControlObject.source,
                                onChange: _cache[59] || (_cache[59] = ($event: any) => (_ctx.getFrameworkControls(_ctx.customCloneControlObject.controlOptionFrameWork))),
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                    'inputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlOptionFrameWork === '',
                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlOptionFrameWork !== ''
                                    }])
                              }, null, 8, ["modelValue", "options", "disabled", "class"]))
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addpopup}])
                        }, [
                          _cache[190] || (_cache[190] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                          (_ctx.addpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_370, _toDisplayString(_ctx.customCloneControlObject.frameworkControls || 'N/A'), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_371, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.customCloneControlObject.frameworkControls,
                                  "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.customCloneControlObject.frameworkControls) = $event)),
                                  options: _ctx.frameworkControls,
                                  optionValue: "value",
                                  optionLabel: "label",
                                  disabled: !_ctx.customCloneControlObject.controlOptionFrameWork || !_ctx.customCloneControlObject.source,
                                  appendTo: "self",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                            'inputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlOptionFrameWork === '',
                                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.customCloneControlObject.controlOptionFrameWork !== ''
                                                    }])
                                }, null, 8, ["modelValue", "options", "disabled", "class"])
                              ]))
                        ], 2)
                      ])
                    ])
                  ])
                ], 8, _hoisted_309)
              ]),
              (_ctx.clonepopup=true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_372, [
                    _cache[191] || (_cache[191] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    (!_ctx.customCloneControlObject._id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_373, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatusForCloneControl ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onCancelbtnCustomForCloning('cancel')))
                          }, "Reset", 10, _hoisted_374),
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary", _ctx.disableStatusForCloneControl ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.saveCustomControlForCloning(_ctx.customCloneControlObject)))
                          }, "Save", 10, _hoisted_375)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedTabIndex == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_376, [
                    _cache[192] || (_cache[192] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_377, [
                      _createElementVNode("button", {
                        class: "btnprimary",
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.saveControlsChangeForActivity(10301)))
                      }, "Active", 8, _hoisted_378)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedTabIndex==3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_379, [
                    _cache[193] || (_cache[193] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_380, [
                      _createElementVNode("button", {
                        class: "btnprimary",
                        onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.active(_ctx.customControlObject)))
                      }, "Active")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.controlEditPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.controlEditPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_381, [
              _createElementVNode("h1", _hoisted_382, _toDisplayString(_ctx.controlsData?.controlTitle||'N/A'), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.onCancelbtnCustom('close')))
              }, _cache[194] || (_cache[194] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_383, [
              _createElementVNode("div", _hoisted_384, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_385, [
                      _createElementVNode("div", _hoisted_386, [
                        (_ctx.addControlpopup==true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_387, [
                              _createElementVNode("div", _hoisted_388, [
                                _cache[195] || (_cache[195] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlTitle.$error
                                        }]),
                                  placeholder: "Title",
                                  onInput: _cache[66] || (_cache[66] = ($event: any) => (_ctx.v$.customControlObject.controlTitle.$touch())),
                                  "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.customControlObject.controlTitle) = $event))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlTitle,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.customControlObject.controlTitle.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_389, [
                                      (_ctx.v$.customControlObject.controlTitle.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_390, "Required"))
                                        : (_ctx.v$.customControlObject.controlTitle && _ctx.v$.customControlObject.controlTitle.restrictCharacters100.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_391, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_392, [
                          _createElementVNode("div", _hoisted_393, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-3/6", {'topspace': _ctx.addControlpopup}])
                            }, [
                              _cache[196] || (_cache[196] = _createElementVNode("label", { class: "controllabel" }, "Frequency", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.controlsEditData.controlFrequency,
                                "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.controlsEditData.controlFrequency) = $event)),
                                options: _ctx.dbFrequency,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                    'is-invalid': _ctx.v$.controlsEditData.controlFrequency.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.customControlObject.controlFrequency === '',
                                                }])
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.controlsEditData.controlFrequency.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_394, [
                                    (_ctx.v$.controlsEditData.controlFrequency.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_395, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12 pl-4", {'topspace': _ctx.addControlpopup}])
                            }, [
                              _cache[197] || (_cache[197] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.controlsEditData.controlPriority,
                                "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.controlsEditData.controlPriority) = $event)),
                                options: _ctx.dbPriority,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                'is-invalid': _ctx.v$.controlsEditData.controlPriority.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.controlsEditData.controlPriority === '',
                                            }])
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.controlsEditData.controlPriority.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_396, [
                                    (_ctx.v$.controlsEditData.controlPriority.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_397, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_398, [
                          _createElementVNode("div", _hoisted_399, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addControlpopup}])
                            }, [
                              _cache[198] || (_cache[198] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                              (_ctx.addControlpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_400, _toDisplayString(_ctx.controlsData.clientUniqueId || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "text",
                                    class: "inputboxstyling mt-2",
                                    "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.customControlObject.clientUniqueId) = $event)),
                                    onInput: _cache[71] || (_cache[71] = ($event: any) => (_ctx.v$.customControlObject.clientUniqueId.$touch())),
                                    placeholder: "Number",
                                    disabled: ""
                                  }, null, 544)), [
                                    [
                                      _vModelText,
                                      _ctx.customControlObject.clientUniqueId,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12 pl-4", {'topspace': _ctx.addControlpopup}])
                            }, [
                              _createElementVNode("div", null, [
                                _cache[199] || (_cache[199] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                                _createElementVNode("div", _hoisted_401, [
                                  (_ctx.addControlpopup==false)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_402, _toDisplayString(_ctx.controlsData.controlType || 'N/A'), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_403, [
                                        _createVNode(_component_AutoComplete, {
                                          modelValue: _ctx.customControlObject.controlType,
                                          "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.customControlObject.controlType) = $event)),
                                          suggestions: _ctx.filteredControlTypeOptions,
                                          onComplete: _ctx.asyncFindControlType,
                                          field: "label",
                                          forceSelection: true,
                                          placeholder: "Category",
                                          class: "p-inputtext-sm systemsstyling mt-2"
                                        }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                      ])),
                                  (_ctx.v$.customControlObject.controlType.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_404, [
                                        (_ctx.v$.customControlObject.controlType && _ctx.v$.customControlObject.controlType.restrictCharacters300.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_405, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_406, [
                          _createElementVNode("div", _hoisted_407, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6/12", {'topspace': _ctx.addControlpopup}])
                            }, [
                              _cache[201] || (_cache[201] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                              (_ctx.addControlpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_408, _toDisplayString(_ctx.controlsData.controlFamily || 'N/A'), 1))
                                : (_openBlock(), _createBlock(_component_multiselect, {
                                    key: 1,
                                    modelValue: _ctx.customControlObject.controlFamily,
                                    "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.customControlObject.controlFamily) = $event)),
                                    options: _ctx.filteredControlFamilyOptions,
                                    showNoOptions: false,
                                    onSearchChange: _ctx.asyncFindControlFamily,
                                    multiple: false,
                                    searchable: true,
                                    "open-direction": "bottom",
                                    hideArrow: false,
                                    placeholder: "Family",
                                    class: "custom-multiselect userSelect mt-2"
                                  }, {
                                    noResult: _withCtx(() => _cache[200] || (_cache[200] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Families Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "options", "onSearchChange"]))
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-3/6 pl-4", {'topspace': _ctx.addControlpopup}])
                            }, [
                              _cache[202] || (_cache[202] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                              (_ctx.addControlpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_409, _toDisplayString(_ctx.controlsData.controlClass || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "text",
                                    class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': _ctx.v$.customControlObject.controlClass.$error
                                            }]),
                                    onInput: _cache[74] || (_cache[74] = ($event: any) => (_ctx.v$.customControlObject.controlClass.$touch())),
                                    placeholder: "Class",
                                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.customControlObject.controlClass) = $event))
                                  }, null, 34)), [
                                    [
                                      _vModelText,
                                      _ctx.customControlObject.controlClass,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                              (_ctx.v$.customControlObject.controlClass.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_410, [
                                    (_ctx.v$.customControlObject.controlClass && _ctx.v$.customControlObject.controlClass.restrictCharacters300.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_411, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full mt-3", {'topspace': _ctx.addControlpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_412, [
                            _cache[203] || (_cache[203] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.controlOwnerSelection,
                              "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.controlOwnerSelection) = $event)),
                              suggestions: _ctx.filteredControlOwnerOptions,
                              onComplete: _ctx.asyncFindControlOwner,
                              onItemSelect: _cache[77] || (_cache[77] = ($event: any) => (_ctx.onControlOwnerPicked($event, _ctx.controlsEditData))),
                              optionLabel: "label",
                              field: "label",
                              forceSelection: true,
                              placeholder: "Please select one",
                              class: "p-inputtext-sm systemsstyling mt-2 w-full"
                            }, null, 8, ["modelValue", "suggestions", "onComplete"])
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addControlpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_413, [
                            _cache[204] || (_cache[204] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                            (_ctx.addControlpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_414, _toDisplayString(_ctx.controlsData.Description || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.Description.$error
                                        }]),
                                  placeholder: "Description",
                                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.customControlObject.Description) = $event)),
                                  onInput: _cache[79] || (_cache[79] = ($event: any) => (_ctx.v$.customControlObject.Description.$touch()))
                                }, "                                    ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.Description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.Description.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_415, [
                                  (_ctx.v$.customControlObject.Description && _ctx.v$.customControlObject.Description.restrictCharacters300.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_416, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addControlpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_417, [
                            _cache[205] || (_cache[205] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                            (_ctx.addControlpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_418, _toDisplayString(_ctx.controlsData.controlMaintenanceTask || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlMaintenanceTask.$error
                                        }]),
                                  placeholder: "Tasks",
                                  "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.customControlObject.controlMaintenanceTask) = $event)),
                                  onInput: _cache[81] || (_cache[81] = ($event: any) => (_ctx.v$.customControlObject.controlMaintenanceTask.$touch()))
                                }, "                                    ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlMaintenanceTask,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlMaintenanceTask.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_419, [
                                  (_ctx.v$.customControlObject.controlMaintenanceTask && _ctx.v$.customControlObject.controlMaintenanceTask.restrictCharacters300.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_420, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addControlpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_421, [
                            _cache[206] || (_cache[206] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                            (_ctx.addControlpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_422, _toDisplayString(_ctx.controlsData.controlPolicies || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlPolicies.$error
                                        }]),
                                  placeholder: "Policies",
                                  "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.customControlObject.controlPolicies) = $event)),
                                  onInput: _cache[83] || (_cache[83] = ($event: any) => (_ctx.v$.customControlObject.controlPolicies.$touch()))
                                }, "                                    ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlPolicies,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlPolicies.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_423, [
                                  (_ctx.v$.customControlObject.controlPolicies && _ctx.v$.customControlObject.controlPolicies.restrictCharacters300.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_424, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addControlpopup}])
                        }, [
                          _createElementVNode("div", _hoisted_425, [
                            _cache[207] || (_cache[207] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                            (_ctx.addControlpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_426, _toDisplayString(_ctx.controlsData.controlGuidance || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.customControlObject.controlGuidance.$error
                                        }]),
                                  placeholder: "Guidance",
                                  "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.customControlObject.controlGuidance) = $event)),
                                  onInput: _cache[85] || (_cache[85] = ($event: any) => (_ctx.v$.customControlObject.controlGuidance.$touch()))
                                }, "                                    ", 34)), [
                                  [
                                    _vModelText,
                                    _ctx.customControlObject.controlGuidance,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.customControlObject.controlGuidance.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_427, [
                                  (_ctx.v$.customControlObject.controlGuidance && _ctx.v$.customControlObject.controlGuidance.restrictCharacters300.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_428, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addControlpopup}])
                        }, [
                          _cache[209] || (_cache[209] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                          (_ctx.addControlpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_429, _toDisplayString(_ctx.controlsData.controlOptionFrameWork || 'N/A'), 1))
                            : (_openBlock(), _createBlock(_component_multiselect, {
                                key: 1,
                                modelValue: _ctx.customControlObject.controlOptionFrameWork,
                                "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.customControlObject.controlOptionFrameWork) = $event)),
                                onSelect: _cache[87] || (_cache[87] = ($event: any) => (_ctx.getFrameworkControls(_ctx.customControlObject.controlOptionFrameWork))),
                                multiple: false,
                                options: _ctx.frameWorksList,
                                searchable: true,
                                "open-direction": "bottom",
                                "close-on-select": true,
                                "clear-on-select": true,
                                "show-labels": false,
                                placeholder: "Frameworks",
                                class: "custom-multiselect mt-2"
                              }, {
                                noResult: _withCtx(() => _cache[208] || (_cache[208] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Frameworks Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "options"]))
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addControlpopup}])
                        }, [
                          _cache[211] || (_cache[211] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                          (_ctx.addControlpopup==false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_430, _toDisplayString(_ctx.controlsData.frameworkControls || 'N/A'), 1))
                            : (_openBlock(), _createBlock(_component_multiselect, {
                                key: 1,
                                modelValue: _ctx.customControlObject.frameworkControls,
                                "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.customControlObject.frameworkControls) = $event)),
                                multiple: false,
                                options: _ctx.frameworkControls,
                                searchable: true,
                                "open-direction": "bottom",
                                "close-on-select": true,
                                "show-labels": false,
                                placeholder: "Controls",
                                class: "custom-multiselect mt-2"
                              }, {
                                noResult: _withCtx(() => _cache[210] || (_cache[210] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Controls Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "options"]))
                        ], 2)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[212] || (_cache[212] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_431, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-1.5", JSON.stringify(_ctx.controlsEditData)!==JSON.stringify(_ctx.dummyControlObj) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.onCancelbtnCustom('activecancel')))
                  }, "Reset", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary", JSON.stringify(_ctx.controlsEditData)!==JSON.stringify(_ctx.dummyControlObj) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.editCustomControl(_ctx.controlsEditData,'edit')))
                  }, "Save", 2)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.deActivatingPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          popUp: _ctx.deActivatingPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_432, [
              _createElementVNode("h1", _hoisted_433, _toDisplayString(_ctx.controlsData?.controlTitle||'N/A'), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.onCancelbtnCustom('deactivateclose')))
              }, _cache[213] || (_cache[213] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_434, [
              _createElementVNode("div", _hoisted_435, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_436, [
                      _createElementVNode("div", _hoisted_437, [
                        _createElementVNode("div", _hoisted_438, [
                          _createElementVNode("div", _hoisted_439, [
                            _cache[214] || (_cache[214] = _createElementVNode("label", { class: "controllabel" }, "Reason/Justification for Deactivating the control", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              type: "text-area",
                              class: _normalizeClass(["inputboxstyling mt-2", {
                                        'is-invalid': _ctx.v$.deActiveControlObject.justification.$error
                                    }]),
                              placeholder: "Reason/Justification for Deactivating the control",
                              onInput: _cache[92] || (_cache[92] = ($event: any) => (_ctx.v$.deActiveControlObject.justification.$touch())),
                              "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.deActiveControlObject.justification) = $event))
                            }, " ", 34), [
                              [_vModelText, _ctx.deActiveControlObject.justification]
                            ]),
                            (_ctx.v$.deActiveControlObject.justification.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_440, [
                                  (_ctx.v$.deActiveControlObject.justification.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_441, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[215] || (_cache[215] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_442, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-1.5", _ctx.isObjectEmpty(_ctx.deActiveControlObject) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.onCancelbtnCustom('deactivecancel')))
                  }, " Reset ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary", _ctx.isObjectEmpty(_ctx.deActiveControlObject) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.editCustomControl(_ctx.deActiveControlObject,'deActive')))
                  }, " Save ", 2)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MessageDialog, {
      visible: _ctx.showMessageDialog,
      "onUpdate:visible": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.showMessageDialog) = $event)),
      activeControls: [_ctx.systemObj],
      mode: _ctx.messageDialogMode,
      systemName: _ctx.systemObj?.systemName || '',
      systemIcon: _ctx.systemObj?.imageUrl || _ctx.systemObj?.imageUrl || _ctx.systemObj?.systemIcon || '',
      tasks: _ctx.inProgressTasks,
      loadingMessage: _ctx.messageDialogLoadingText,
      onCancel: _ctx.onMessageDialogCancel,
      onManageControls: _ctx.onManageControls,
      onOk: _ctx.onMessageDialogOk,
      onOkTasks: _ctx.onMessageDialogOkTasks
    }, null, 8, ["visible", "activeControls", "mode", "systemName", "systemIcon", "tasks", "loadingMessage", "onCancel", "onManageControls", "onOk", "onOkTasks"])
  ], 64))
}